export default "__VITE_ASSET__zMWDxHbA__"